const Layout = () => import(/* webpackChunkName: 'index' */ '../page/layout')

const staticRoute = [
    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/login',
        // component: () => import(/* webpackChunkName: 'login' */ '../page/login/login')
        component: () => import(/* webpackChunkName: 'login' */ '../page/login/loginDB')
    },
    {
        path: '/selectH',
        component: () => import(/* webpackChunkName: 'home' */ '../page/selectH'),
    },
]

export default staticRoute


// WEBPACK FOOTER //
// ./src/router/staticRoute.js